import React, { useEffect, useState } from "react";
import { post } from "../../apiService";

import { useDispatch, useSelector } from "react-redux";
import { setUserToken } from "../../features/authSlice";
import {
  setProfile,
  storeToken,
  setAddToCart,
} from "../../services/localStorageServices";
import "./Login.css";
import { Button, ConfigProvider, Form, Input, message } from "antd";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { BiSolidPlaneAlt } from "react-icons/bi";
import { ImSpinner } from "react-icons/im";
import { FaRegEye, FaShieldAlt } from "react-icons/fa";
import { IoDiamondOutline } from "react-icons/io5";
import { FaCircleUser } from "react-icons/fa6";
import { RiLockPasswordFill } from "react-icons/ri";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    // dispatch(setUserToken({ token: access_token }));
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onFinish = async (values) => {
    // console.log('Success:', values);
    const formData = new FormData();
    formData.append("action", "verify_login");
    formData.append("user_name", values.userName);
    formData.append("user_password", values.password);

    try {
      const response = await post("/user.php", formData);
      if (response) {
        message.success("Login successfully!");
        dispatch(setUserToken({ token: response.profile.token }));
        storeToken(response.profile.token);
        setProfile(response.profile);

        if (response.profile.type === "user") {
          setAddToCart([]);
          navigate("/");
        } else {
          navigate("/admin-panel");
        }
      } else {
        message.error("Invalid username or password");
        console.error("Failed to send data to the API.");
      }
    } catch (error) {
      message.error("Invalid username or password");
      console.log(error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const items = [
    {
      text: "Free Shipping To Your Doorstep",
      icon: <BiSolidPlaneAlt />,
      color: "#23c6c8",
    },
    {
      text: "Calibrated Sizes From 0.5mm To 3.2mm",
      icon: <ImSpinner />,
      color: "#ed5565",
    },
    {
      text: "Consistent and Precise Quality Assortments",
      icon: <FaRegEye />,
      color: "purple",
    },
    {
      text: "100% Natural Diamonds and Ethical Sourcing",
      icon: <IoDiamondOutline />,
      color: "green",
    },
    {
      text: "Reputed and Recognized Since 40 Plus Years. Worldwide Dealers",
      icon: <FaShieldAlt />,
      color: "#f8ac59",
    },
  ];
  return (
    <>
      <section>
        <div className="account_page">
          <div className="container curved-edge-login">
            <div className="account-box login">
              <h3 className="login-title"> Login </h3>
              <ConfigProvider
                theme={{
                  token: {
                    borderRadius: "",
                    colorPrimary: "#217DC1",
                    // controlHeight:"5px"
                  },
                }}
              >
                <Form
                  name="basic"
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  autoComplete="off"
                >
                  <Form.Item
                    // label="Email"
                    name="userName"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Username!",
                      },
                    ]}
                  >
                    <Input
                      className="login-email-pass-input"
                      placeholder="Username"
                      prefix={<FaCircleUser />}
                    />
                  </Form.Item>

                  <Form.Item
                  className="m-0"
                    // label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input.Password
                      className="login-email-pass-input"
                      placeholder="Password"
                      prefix={<RiLockPasswordFill />}
                    />
                  </Form.Item>
                  <Form.Item className="my-3">
                    <NavLink to="/forgot-password">
                      Forgot Password
                    </NavLink>
                  </Form.Item>
                  <ConfigProvider
                    theme={{
                      token: {
                        controlHeight: "40px",
                        borderRadius: "20px",
                      },
                    }}
                  >
                    <Form.Item>
                      <Button
                        className="w-100 fs-5"
                        type="primary"
                        htmlType="submit"
                      >
                        Login
                      </Button>
                    </Form.Item>
                  </ConfigProvider>
                </Form>
              </ConfigProvider>
              <Link to="/registration">
                <h6 className="text-center dont-have-an-account">
                  I don't have an account?&nbsp;
                  <span style={{ color: "blue", cursor: "pointer" }}>
                    Register
                  </span>
                </h6>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
